export const environment = {
  production: false,
  apiBaseUrl: "https://dev.app.processeye.wideum.com" //"https://192.168.1.130:7219" //
};
